export const en = {
    'error-display-conditions': 'An error occurred. Please try again.',
    'fetch-moderation-reject-reasons-error': 'Unable to get rejection reasons. Please try again',
    'many-image-can-load': 'Only {count} images can be uploaded to this ad group',
    'not-loaded-files-button': 'OK',
    'not-loaded-files-title': 'The following files were not uploaded',
    'one-image-can-load': 'Only one image can be uploaded to this ad group',
    'some-image-can-load': 'Only {count} images can be uploaded to this ad group',
    'warning-about-changes': 'Changes will not be saved. Continue?'
};
